module.exports = __webpack_public_path__ + "img/assessment.2f7446c0.svg";